import { Dropdown, Layout, Select } from "antd";
import type { MenuProps } from 'antd';
import i18next from "i18next";

import config from "config";
import { useHooks } from "hooks";
import useStore from "store";
import { privateRoutes, IRoute } from "routes/data";

import Avatar from 'assets/images/ava.svg'
import { Logout, ProfileArrow, SelectArrow, UserCircle } from "assets/images/icons";

import './style.scss'

const { Header } = Layout;

const HeaderComponent = () => {
  const { get, location, t, navigate } = useHooks();
  const {
    system,
    auth: { data },
  } = useStore();
  const { Option } = Select;

  const userData = get(data, "data")

  const changeLang = (langCode: string) => {
    i18next.changeLanguage(langCode);
  };

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
  };

  const items: MenuProps['items'] = [
    {
      label: 'Profile',
      key: '/profile',
      icon: <UserCircle />,
    },
    {
      label: 'Logout',
      key: '/logout',
      icon: <Logout />,
    }
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const findRouteTitle = (pathname: string, routes: IRoute[]): string => {
    const cleanPath = pathname.includes('/') && /\/\d+$/.test(pathname)
      ? pathname.substring(0, pathname.lastIndexOf('/'))
      : pathname;
    const route = routes.find(route => {
      const routePath = route.path.includes(':')
        ? route.path.substring(0, route.path.lastIndexOf('/'))
        : route.path;
      return routePath === cleanPath;
    });
    return route?.title || '';
  };

  const pathname = get(location, "pathname");
  const title = findRouteTitle(pathname, privateRoutes);


  return (
    <Header className="header flex justify-between items-center px-[30px] py-[20px] bgc-[#fff]">
      <div className="relative">
        <span className="font-[500] text-[16px] text-[#77828A] ml-[48px]">
          {t(`${title}`)}
        </span>
      </div>
      <div className="flex items-center">
        <Select
          defaultValue={system?.lang}
          size={"large"}
          suffixIcon={<SelectArrow />}
          onChange={(value: any) => {
            changeLang(value);
          }}
        >
          {config.API_LANGUAGES.map((lang) => (
            <Option key={lang.code} value={lang?.code}>{get(lang, 'title', '')}</Option>
          ))}
        </Select>
        <div className="profile-panel mr-[50px]">
          <div className="profile-info">
            <p className="profile-name">{get(userData, "firstname", "user") + " " + get(userData, "lastname", "")}</p>
            <p className="profile-role">{get(userData, "role", "user")}</p>
          </div>
          <div className="profile-avatar">
            <img src={get(userData, "photo_url.url", Avatar)} alt="avatar" />
            <Dropdown.Button className="border-none" menu={menuProps} icon={<ProfileArrow />} ></Dropdown.Button>
          </div>
        </div>
      </div>
    </Header>
  );
};

export default HeaderComponent;
